import { itemMaster } from "./ItemMaster";

export const itemService = {
  itemMaster,
};
